import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostBinding } from '@angular/core';

@Component({
  selector: 'alg-accordion-header',
  templateUrl: './alg-accordion-header.component.html',
  styleUrls: ['./alg-accordion-header.component.scss']
})
export class AlgAccordionHeaderComponent implements OnInit, OnChanges {
  @Input() icon: string;
  @Input() title: string;
  @Input() status: string;
  @Input() open: boolean = false;
  @Output() onToggle: EventEmitter<string>;
  @HostBinding('class.active') active: boolean;
  @HostBinding('class.completed') completed: boolean;

  public actualIcon: string;
  public collapseIcon: string = 'plus-circle';
  constructor() { }

  private manageStatus(status) {
    switch(status) {
      case 'active':
        this.actualIcon = `${this.icon}-fill`;
        this.active =  true;
        this.completed = false;
        break;
      case 'completed':
        this.actualIcon = 'success';
        this.completed = true;
        this.active = false;
        break;
      default:
        this.actualIcon = `${this.icon}-empty`;
        this.active = false;
        this.completed = false;
        break;
    }
  }
  private manageOpen(open){
    this.collapseIcon = open ? 'minus-circle' : 'plus-circle';
  }

  ngOnInit() {
    this.manageStatus(this.status);
    this.manageOpen(this.open);
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.icon || changes.status){
      this.manageStatus(changes.status.currentValue || this.status);
    }
    if(changes.open){
      this.manageOpen(changes.open.currentValue || this.open);
    }
  }

  public toggle(){
    if(this.status !== 'disable'){
      this.onToggle.emit(this.status);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-accordion-header/alg-accordion-header.component.ts